// extracted by mini-css-extract-plugin
export default {"tableColumn":"TableColumn_tableColumn__FaOmz"};